import script from "./JournalEntry.vue?vue&type=script&setup=true&lang=js"
export * from "./JournalEntry.vue?vue&type=script&setup=true&lang=js"

import "./JournalEntry.vue?vue&type=style&index=0&id=45ae69b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45ae69b4"]])

export default __exports__